import { FiActivity } from 'react-icons/fi';
import { LuWrench } from 'react-icons/lu';
import { GoXCircle } from 'react-icons/go';
import { CiWifiOff } from 'react-icons/ci';
import type { IconType } from 'react-icons';
import { SortKey, SystemStatus, SystemStatusColors } from '../types';

/* ---------------------- System Status Colors ---------------------- */

export const SYSTEM_STATUS_COLORS: Record<SystemStatus, SystemStatusColors> = {
  [SystemStatus.OPERATIONAL]: {
    core: '#1db870',
    background: '#163a28',
    bright: '#3ddc8c',
  },
  [SystemStatus.MAINTENANCE]: {
    core: '#d49018',
    background: '#3a2a06',
    bright: '#ffca28',
  },
  [SystemStatus.GROUNDED]: {
    core: '#d44040',
    background: '#3a1010',
    bright: '#ff6b6b',
  },
  [SystemStatus.OFFLINE]: {
    core: '#A7A2A0',
    background: '#4D4342',
    bright: '#C4C1BF',
  },
};

/* ---------------------- System Status Configs ---------------------- */

export interface SystemStatusConfig {
  status: SystemStatus;
  label: string;
  icon: IconType;
  iconStrokeWidth: number;
  colors: SystemStatusColors;
}

export const SYSTEM_STATUS_CONFIGS: SystemStatusConfig[] = [
  {
    status: SystemStatus.OPERATIONAL,
    label: 'OPERATIONAL',
    icon: FiActivity,
    iconStrokeWidth: 2,
    colors: SYSTEM_STATUS_COLORS[SystemStatus.OPERATIONAL],
  },
  {
    status: SystemStatus.MAINTENANCE,
    label: 'MAINTENANCE',
    icon: LuWrench,
    iconStrokeWidth: 1.5,
    colors: SYSTEM_STATUS_COLORS[SystemStatus.MAINTENANCE],
  },
  {
    status: SystemStatus.GROUNDED,
    label: 'GROUNDED',
    icon: GoXCircle,
    iconStrokeWidth: 0.75,
    colors: SYSTEM_STATUS_COLORS[SystemStatus.GROUNDED],
  },
  {
    status: SystemStatus.OFFLINE,
    label: 'OFFLINE',
    icon: CiWifiOff,
    iconStrokeWidth: 1,
    colors: SYSTEM_STATUS_COLORS[SystemStatus.OFFLINE],
  },
];

/* ---------------------- Sorting Options ---------------------- */

export const BASE_SORT_OPTIONS: { key: SortKey; label: string }[] = [
  { key: SortKey.MOST_MISSIONS, label: 'Most Missions' },
  { key: SortKey.AVERAGE_MISSION_DURATION, label: 'Avg Mission Time' },
  { key: SortKey.NUMBER_OF_NIGHT_MISSIONS, label: 'Night Missions' },
  { key: SortKey.NUMBER_OF_DAY_MISSIONS, label: 'Day Missions' },
];

/* ---------------------- Layout Values ---------------------- */

export const DASHBOARD_LAYOUT = {
  assetRosterPreferredWidth: 'w-80',
  assetRosterMinWidth: 'min-w-[100px]',
  assetRosterGridBreakpoint: 'min-[300px]:grid-cols-2',
};
